import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { ShoppingBag, Award, ListChecks } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";

export default function CustomerDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    if (!user) { navigate("/login"); return; }
    api.get("/orders/me").then(({data}) => setOrders(data)).catch(() => {});
  }, [user, navigate]);
  if (!user) return null;
  return (
    <div className="max-w-6xl mx-auto px-4 lg:px-8 py-10" data-testid="customer-dashboard">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-heading text-4xl text-[#1A2421]">Hello, {user.name?.split(' ')[0]}</h1>
          <p className="text-[#5C6B64]">Welcome back to your royal account.</p>
        </div>
        <button onClick={async () => { await logout(); navigate("/"); }} data-testid="customer-logout" className="text-sm text-[#8B0000]">Logout</button>
      </div>

      <div className="grid sm:grid-cols-3 gap-4 mb-8">
        <div className="bg-[#050505] text-[#FAF9F6] rounded-xl p-6 col-span-2">
          <BrandLogo type="customer" size="sm" showText={false} className="mb-2" />
          <div className="font-accent text-xs text-[#D4AF37]">ROYAL REWARDS BALANCE</div>
          <div className="font-heading text-5xl text-[#D4AF37]">{user.points || 0} <span className="text-base">pts</span></div>
          <div className="text-sm text-[#FAF9F6]/60 mt-1">Tier: {user.tier}</div>
        </div>
        <Link to="/restaurant" className="mart-card p-6 flex flex-col justify-between" data-testid="quick-order">
          <ShoppingBag className="w-7 h-7 text-[#D4AF37]"/>
          <div className="font-heading text-2xl text-[#1A2421] mt-4">Order again</div>
          <div className="text-xs text-[#5C6B64]">Re-order favorites in seconds</div>
        </Link>
      </div>

      <h2 className="font-heading text-2xl text-[#1A2421] mb-3 flex items-center gap-2"><ListChecks className="w-5 h-5"/> Recent orders</h2>
      <div className="space-y-3">
        {orders.length === 0 && <p className="text-[#5C6B64]">No orders yet. <Link to="/restaurant" className="text-[#2C4A3B] font-semibold underline">Try the menu</Link>.</p>}
        {orders.map((o) => (
          <Link to={`/order/${o.id}`} key={o.id} className="mart-card p-4 flex items-center justify-between hover:border-[#2C4A3B]" data-testid={`order-${o.id}`}>
            <div>
              <div className="font-accent text-xs text-[#D4AF37]">{o.order_number}</div>
              <div className="font-heading text-lg text-[#1A2421]">{o.items.length} items · {o.fulfillment}</div>
              <div className="text-xs text-[#5C6B64]">{new Date(o.created_at).toLocaleString()}</div>
            </div>
            <div className="text-right">
              <div className="font-heading text-xl text-[#2C4A3B]">${o.total.toFixed(2)}</div>
              <div className="text-xs uppercase tracking-wider text-[#D4AF37] font-accent">{o.status}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
